import { ReactNode } from "react";
import { createContext, useContext } from "react";

interface ShipmentMapContextValue {
  data?: ShipmentMapData;
  isLoading: boolean;
  isError: boolean;
  error?: Error | null;
}

const ShipmentMapContext = createContext<ShipmentMapContextValue | undefined>(undefined);

export function useShipmentMapContext() {
  const context = useContext(ShipmentMapContext);
  if (!context) {
    throw new Error('useShipmentMapContext must be used within ShipmentMapProvider');
  }
  return context;
}

interface ShipmentMapProviderProps {
  children: ReactNode;
  value: ShipmentMapContextValue;
}

export function ShipmentMapProvider({ children, value }: ShipmentMapProviderProps) {
  return (
    <ShipmentMapContext.Provider value={value}>{children}</ShipmentMapContext.Provider>
  );
}

export interface LocationData {
  latitude?: number | null;
  longitude?: number | null;
  pixelX?: number | null;
  pixelY?: number | null;
}

export interface ShipmentMapData {
  mapSasUrl?: string | null;
  currentLocation?: LocationData | null;
  destination?: LocationData | null;
  centerLatitude?: number | null;
  centerLongitude?: number | null;
  zoomLevel?: number | null;
  width?: number | null;
  height?: number | null;
}
